import React, { FC } from 'react';

export const IconEditAtAllLocations: FC<React.PropsWithChildren<{ className?: string }>> = ({ className }) => (
  <svg className={className} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7069 13.7929L10.2929 15.207L5.29288 10.207L6.70694 8.7929L11.7069 13.7929Z" fill="#101010" />
    <path
      // eslint-disable-next-line max-len
      d="M12.4999 5.87884C13.0857 5.29305 14.0352 5.29305 14.621 5.87884C15.2066 6.46464 15.2067 7.41421 14.621 7.99993C14.0353 8.5855 13.0857 8.58545 12.4999 7.99993C11.9142 7.41419 11.9143 6.46463 12.4999 5.87884Z"
      fill="#101010"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M10.6317 0.00871794L18.6317 1.07122L18.7958 1.10735C19.1657 1.2218 19.4424 1.54422 19.4921 1.93841L20.4921 9.87493C20.5311 10.1856 20.4223 10.4971 20.1982 10.7157L10.4628 20.2157C10.071 20.5978 9.44462 20.5938 9.05753 20.207L0.292878 11.4423C-0.0941945 11.0552 -0.0980754 10.4289 0.284089 10.037L9.78409 0.301687C10.0045 0.0758017 10.3189 -0.0328554 10.6317 0.00871794ZM2.40518 10.7265L9.77237 18.0937L18.4452 9.63079L17.6034 2.95208L10.8651 2.05657L2.40518 10.7265Z"
      fill="#101010"
    />
  </svg>
);
